<template>
  <div class="product-page">
    <div v-if="Object.keys(product).length > 0 && !errorMessage" class="product-detail">
      <div v-if="isMobile">
        <div class="product-info">
          <div class="header-row">
            <p>{{ product.name }}</p>
          </div>
          <p class="desc">{{ formatDescription() }}</p>
        </div>
        <div class="product-image">
          <div v-if="isImageLoading" class="image-loader">
            <div class="spinner"></div>
          </div>
          <div class="image-click-areas">
            <div v-if="productImages.length > 1" class="image-click-left" @click.stop="prevImage"></div>
            <div class="image-click-middle" @click="openLightbox"></div>
            <div v-if="productImages.length > 1" class="image-click-right" @click.stop="nextImage"></div>
          </div>
          <img :src="productImages[currentImageIndex]" :alt="product.name" @load="onImageLoad" v-show="!isImageLoading" />
          <div v-if="productImages.length > 1 && !isImageLoading" class="image-controls">
            <button class="image-arrow left-arrow" @click="prevImage">❮</button>
            <button class="image-arrow right-arrow" @click="nextImage">❯</button>
          </div>
          <div class="image-indicators" v-if="!isImageLoading">
            <span v-for="(img, index) in productImages" :key="index" 
                  :class="{ active: index === currentImageIndex }"
                  @click="goToImage(index)"></span>
          </div>
        </div>
        <div class="product-options">
          <div class="column left-column">
            <p v-if="product.rental_price === '<price_individually>'" class="price">{{ translations.price_individually
              }}
            </p>
            <div v-else>
              <p  class="price">{{ product.rental_price }} {{ translations.price_suffix }}</p>
              <br />
              <p v-if="product.category === 'glass' && product.meta.quantity> 1">
                {{ this.productQuantity / (product.meta.quantity) }} x kosz (po {{ product.meta.quantity }} szt.)
              </p>
              <br />
            </div>
          </div>
          <div class="vertical-line"></div>
          <div class="column right-column">
            <div class="options">
              <div class="option">
                <label for="quantity">{{ translations.add_cart.quantity }} </label>
                <button type="button" class="stepper__btn" aria-label="Zmniejsz" @click="dec('quantity')">-</button>

                <input id="quantity" type="number" v-model="productQuantity" :min="minQuantity" :step="stepQuantity"
                  @keydown="stepQuantity > 1 ? $event.preventDefault() : null"
                  :class="{ 'with-spinners': tryb === 'native' }" />
                <button type="button" class="stepper__btn" aria-label="Zwiększ"
                  @click="inc('quantity', maxQuantity)">+</button>
              </div>
              <div class="option">
                <label for="days">{{ translations.add_cart.days }}</label>
                <button type="button" class="stepper__btn" aria-label="Zmniejsz dni" @click="dec('days')">-</button>
                <input id="days" type="number" :class="{ 'with-spinners': tryb === 'native' }" v-model="daysQuantity"
                  min="1" />
                <button type="button" class="stepper__btn" aria-label="Zwiększ dni" @click="inc('days')">+</button>
              </div>
              <div class="option">
                <label for="days">SUMA NETTO</label>
                <p class="sum_net"> {{ formatRentalPrice(totalPrice) }} </p>
              </div>
            </div>
            <button class="product-button" @click="handleAddToCart(product)">{{ translations.add_cart.button }}</button>
          </div>
        </div>

      </div>

      <div v-if="!isMobile" class="product-image">
        <div v-if="isImageLoading" class="image-loader">
          <div class="spinner"></div>
        </div>
        <div class="image-click-areas">
          <div v-if="productImages.length > 1" class="image-click-left" @click.stop="prevImage"></div>
          <div class="image-click-middle" @click="openLightbox"></div>
          <div v-if="productImages.length > 1" class="image-click-right" @click.stop="nextImage"></div>
        </div>
        <img :src="productImages[currentImageIndex]" :alt="product.name" @load="onImageLoad" v-show="!isImageLoading" />
        <div v-if="productImages.length > 1 && !isImageLoading" class="image-controls">
          <button class="image-arrow left-arrow" @click="prevImage">❮</button>
          <button class="image-arrow right-arrow" @click="nextImage">❯</button>
        </div>
        <div class="image-indicators" v-if="!isImageLoading">
          <span v-for="(img, index) in productImages" :key="index" 
                :class="{ active: index === currentImageIndex }"
                @click="goToImage(index)"></span>
        </div>
      </div>
      <div v-if="!isMobile" class="block">
        <div class="product-info">
          <div class="header-row">
            <p>{{ product.name }}</p>
          </div>
          <p class="desc">{{ formatDescription() }}</p>
        </div>
        <div class="product-options">
          <div class="column left-column">
            <p v-if="product.rental_price === '<price_individually>'" class="price">{{ translations.price_individually
              }}
            </p>
            <div v-else>
              <p  class="price">{{ product.rental_price }} {{ translations.price_suffix }}</p>
              <br />
              <p v-if="product.category === 'glass' && product.meta.quantity> 1">
                {{ this.productQuantity / (product.meta.quantity) }} x {{ translations.bascket }} ({{ translations.in }} {{ product.meta.quantity }} {{ translations.pcs }})
              </p>
              <br />
            </div>
          </div>
          <div class="vertical-line"></div>
          <div class="column right-column">
            <div class="options">
              <div class="option">
                <label for="quantity">{{ translations.add_cart.quantity }} </label>
                <input id="quantity" type="number" v-model="productQuantity" :min="minQuantity" :step="stepQuantity"
                  @keydown="stepQuantity > 1 ? $event.preventDefault() : null"
                  :class="{ 'with-spinners': tryb === 'native' }" />
              </div>
              <div class="option">
                <label for="days">{{ translations.add_cart.days }}</label>
                <input id="days" type="number" v-model="daysQuantity" min="1" />
              </div>
              <div class="option">
                <label for="days">{{ translations.sum_net }}</label>
                <p class="sum_net"> {{ formatRentalPrice(totalPrice) }} </p>
              </div>
            </div>
            <button class="product-button" @click="handleAddToCart(product)">{{ translations.add_cart.button }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="tags" v-if="Object.keys(product).length > 0 && !errorMessage">
      <p>{{ product.meta.tags }}</p>
    </div>
    <div v-else-if="errorMessage" class="error-container">
      <p class="error-message">{{ errorMessage }}</p>
      <router-link to="/rent" class="product-button">Powrót do wypożyczalni</router-link>
    </div>
    <CartNotification v-if="showNotification" message="Produkt dodany do koszyka!" />
    <RelatedProducts v-if="Object.keys(product).length > 0 && !errorMessage" />

    <!-- Lightbox Overlay -->
    <div v-if="isLightboxOpen" class="lightbox-overlay" @click.self="closeLightbox">
      <button class="lightbox-close" @click="closeLightbox">×</button>
      <div class="lightbox-content">
        <button v-if="productImages.length > 1" class="lightbox-arrow left" @click.stop="prevImage">❮</button>
        <div class="lightbox-image-container">
          <img :src="productImages[currentImageIndex]" :alt="product.name" class="lightbox-image" />
        </div>
        <button v-if="productImages.length > 1" class="lightbox-arrow right" @click.stop="nextImage">❯</button>
      </div>
      <div class="lightbox-indicators" v-if="productImages.length > 1">
        <span v-for="(img, index) in productImages" :key="index" 
              :class="{ active: index === currentImageIndex }"
              @click.stop="goToImage(index)"></span>
      </div>
    </div>
  </div>
  <AppFooter />
</template>

<script>
import RelatedProducts from './RelatedProducts.vue';
import CartNotification from '@/components/CartNotification.vue';


import { useCartStore } from '../../store/cart';
import { computed } from 'vue';
import { ref } from 'vue';
import AppFooter from './FootBar.vue';
import translationsData from '@/assets/text_lang/translations.json';
import { useLanguageStore } from '@/theme';

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  watch: {
    id(newId) {
      // Wywołaj funkcję pobierania danych dla nowego ID
      this.fetchProductDetails(newId);
    }
  },
  components: {
    RelatedProducts,
    AppFooter,
    CartNotification
  },
  data() {
    return {
      relatedProducts: [],
      currentIndex: 0,
      currentImageIndex: 0,
      productImages: [],
      tags: ['Granitor', 'Carpigiani', '2 komory', '12l', '230V', '3 tryby pracy'],
      visibleCount: 3,
      errorMessage: "",
      isImageLoading: true,
      isLightboxOpen: false,
    };
  }, setup() {
    const languageStore = useLanguageStore();
    const cartStore = useCartStore();
    const showNotification = ref(false);


    const product = ref({});

    const productQuantity = ref(1);
    const daysQuantity = ref(1);

    const minQuantity = ref(1);
    const stepQuantity = ref(1);
    const maxQuantity = ref(25);
    const isMobile = ref(window.innerWidth <= 822);

    const translations = computed(() => {
      return translationsData[languageStore.currentLanguage]["rent"];
    });

    const totalPrice = computed(() => {
      if (!productQuantity.value || !daysQuantity.value) return 0;
      const pricePerDay = product.value.rental_price && product.value.rental_price !== "<price_individually>"
        ? parseFloat(product.value.rental_price)
        : 0;
      return pricePerDay * productQuantity.value * daysQuantity.value;
    });
    function inc(type) {
      if (type === 'quantity' && Number(productQuantity.value)) {
        productQuantity.value = Number(productQuantity.value) + Number(stepQuantity.value);
      }
      if (type === 'days') {
        daysQuantity.value = Number(daysQuantity.value) + 1;
      }

    }
    function dec(type) {
      if (type === 'quantity' && Number(productQuantity.value) > Number(minQuantity.value)) {
        productQuantity.value = Number(productQuantity.value) - Number(stepQuantity.value);
      }
      if (type === 'days' && Number(daysQuantity.value) > 1) {
        daysQuantity.value = Number(daysQuantity.value) - 1;
      }
    }
    function handleAddToCart(product) {
      const productToAdd = {
        ...product,
        quantity: productQuantity.value,
        days: daysQuantity.value
      };

      cartStore.addToCart(productToAdd);
      showNotification.value = true;

      if (product.category === 'glass') {
        productQuantity.value = product.meta.quantity || 1;
        minQuantity.value = product.meta.quantity || 1;
        stepQuantity.value = product.meta.quantity || 1;
      } else {
        productQuantity.value = 1;
        minQuantity.value = 1;
        stepQuantity.value = 1;
      }

      setTimeout(() => {
        showNotification.value = false;
      }, 3000);
    }
    return {
      handleAddToCart,
      product,
      currentLanguage: languageStore.currentLanguage,
      translations,
      showNotification,
      productQuantity,
      minQuantity,
      maxQuantity,
      stepQuantity,
      daysQuantity,
      isMobile,
      totalPrice,
      inc,
      dec,
      imageUrl: process.env.VUE_APP_IMAGE_URL
    };
  },
  computed: {
    visibleProducts() {
      // Zwracamy trzy widoczne produkty w zależności od indeksu
      return this.relatedProducts.slice(this.currentIndex, this.currentIndex + this.visibleCount);
    }
  },
  methods: {
    handleKeydown(e) {
      if (!this.isLightboxOpen) return;
      if (e.key === 'Escape') {
        this.closeLightbox();
      } else if (e.key === 'ArrowRight') {
        this.nextImage();
      } else if (e.key === 'ArrowLeft') {
        this.prevImage();
      }
    },
    openLightbox() {
      this.isLightboxOpen = true;
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', this.handleKeydown);
    },
    closeLightbox() {
      this.isLightboxOpen = false;
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', this.handleKeydown);
    },
    handleResize() {
      const width = window.innerWidth;
      if (width < 780) {
        this.visibleCount = 1;
        this.currentIndex = 0;
      } else if (width < 1200) {
        this.visibleCount = 2;
        this.currentIndex = 0;
      } else {
        this.visibleCount = 3;
        this.currentIndex = 0;
      }
    },
    formatRentalPrice(rental_price) {
      const currency = this.translations.currency;
      return `${rental_price} ${currency}`;
    },
    formatDescription() {
      if (!this.product || !this.product.meta) {
        return {};
      }
      const desc = {
        [this.translations.product_detail.loss_price]: this.product.loss_price || null,
        [this.translations.product_detail.capacity]: this.product.meta.capacity || null,
        [this.translations.product_detail.diameter]: this.product.meta.diameter || null,
        [this.translations.product_detail.height]: this.product.meta.height || null,
        [this.translations.product_detail.weight]: this.product.meta.weight || null,
        [this.translations.product_detail.width]: this.product.meta.width || null,
        [this.translations.product_detail.depth]: this.product.meta.depth || null,
        [this.translations.product_detail.quantity]: this.product.meta.quantity || null,

      };

      return Object.entries(desc)
        .filter(entry => entry[1] !== null)
        .map(([key, value]) => `${key}: ${value}`)
        .join(", ");

    },
    nextSlide() {
      // Jeśli nie jesteśmy na końcu listy, przesuwamy o jeden produkt w prawo
      if (this.currentIndex < this.relatedProducts.length - this.visibleCount) {
        this.currentIndex++;
      }
    },
    prevSlide() {
      // Jeśli nie jesteśmy na początku listy, przesuwamy o jeden produkt w lewo
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 822;
    },
    goToImage(index) {
      if (this.currentImageIndex !== index) {
        this.isImageLoading = true;
        this.currentImageIndex = index;
      }
    },
    nextImage() {
      if (this.productImages.length <= 1) return;
      this.isImageLoading = true;
      if (this.currentImageIndex < this.productImages.length - 1) {
        this.currentImageIndex++;
      } else {
        this.currentImageIndex = 0;
      }
    },
    prevImage() {
      if (this.productImages.length <= 1) return;
      this.isImageLoading = true;
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      } else {
        this.currentImageIndex = this.productImages.length - 1;
      }
    },
    onImageLoad() {
      this.isImageLoading = false;
    },
    preloadImages(urls) {
      urls.forEach(url => {
        const img = new Image();
        img.src = url;
      });
    },
    async fetchProductDetails(productId) {
      try {
        this.errorMessage = "";
        this.isImageLoading = true;
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await fetch(`${apiUrl}/products/${productId}`);
        const data = await response.json();

        if (data.ok === false) {
          this.errorMessage = data.message || "Produkt nie został znaleziony.";
          this.product = {};
          return;
        }
        
        // Handle formats: { products: [...] }, { product: {...} }, and direct product object
        if (data.products && Array.isArray(data.products)) {
          this.product = data.products[0];
        } else if (data.product) {
          this.product = data.product;
        } else {
          this.product = data;
        }
        
        this.currentImageIndex = 0;
        this.productImages = [];
        
        if (Array.isArray(this.product.meta?.images) && this.product.meta.images.length > 0) {
          this.productImages = this.product.meta.images
            .filter(imageName => typeof imageName === 'string' && imageName.trim().length > 0)
            .map(imageName => (
              `${this.imageUrl}${encodeURIComponent(imageName)}`
            ));
          this.preloadImages(this.productImages);
        }

        if (this.product.category === 'glass') {
          this.productQuantity = this.product.meta.quantity || 1;
          this.minQuantity = this.product.meta.quantity || 1;
          this.stepQuantity = this.product.meta.quantity || 1;
        }

        const response_related_products = await fetch(`${apiUrl}/products?category=${this.product.category}`);
        const data_related_products = await response_related_products.json();
        this.relatedProducts = data_related_products.products || [];

        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });

      } catch (error) {
        console.error("Wystąpił błąd podczas pobierania danych produktu:", error);
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.checkIsMobile);
    this.checkIsMobile();
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Ustaw liczbę widocznych produktów przy pierwszym uruchomieniu
    this.fetchProductDetails(this.id);
  },
  beforeUnmount() {  // Zmienione z beforeDestroy
    window.removeEventListener('resize', this.checkIsMobile);
    window.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
html {
  height: 100%;
  overflow-x: hidden;
}

.product-page {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding-top: 290px;
  box-sizing: border-box;
  background-color: var(--dark-color-font);
  color: var(--dark-color-background);
  width: 100%;
  min-height: calc(100vh - 70px);
  /* Zapewnia, że .shop ma co najmniej pełną wysokość okna minus wysokość stopki */
  padding-left: 30px;
  padding-right: 30px;
  /* Upewnij się, że nie zakryje zawartości */
}

.product-detail {
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
  width: 90%;
  max-width: 1700px;
}

.desc {
  margin: 40px 0;
  font-size: 11px;
  font-weight: bold;
}


.product-image img {
  width: 500px;
  height: 500px;
  object-fit: contain;
  margin-right: 20px;
}

.product-image {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-indicators {
  position: relative;
  bottom: 0;
  margin-top: 20px;
  display: flex;
  gap: 10px;
  justify-content: center;
  z-index: 10;
}

.image-indicators span {
  width: 20px;
  height: 20px;
  background-color: transparent;
  border: 3px solid var(--dark-color-background);
  cursor: pointer;
  transition: background-color 0.3s;
}

.image-indicators span.active {
  background-color: var(--dark-color-background);
}

.image-indicators span:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

.image-controls {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 500px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s;
}

.product-image:hover .image-controls {
  opacity: 1;
}

.image-arrow {
  background: none;
  border: none;
  font-size: 3rem;
  color: var(--dark-color-background);
  cursor: pointer;
  pointer-events: all;
  transition: all 0.3s;
  padding: 10px 20px;
  height: 100%;
  display: flex;
  align-items: center;
}

.image-arrow:hover {
  color: var(--dark-color-font);
  background-color: rgba(0, 0, 0, 0.1);
}

.left-arrow {
  margin-left: 0;
}

.right-arrow {
  margin-right: 0;
}

.image-click-areas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 500px;
  display: flex;
  z-index: 5;
  pointer-events: all;
}

.image-click-left {
  width: 25%;
  height: 100%;
  cursor: w-resize;
  transition: background-color 0.3s;
}

.image-click-left:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.image-click-middle {
  flex: 1;
  height: 100%;
  cursor: zoom-in;
  transition: background-color 0.3s;
}

.image-click-middle:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.image-click-right {
  width: 25%;
  height: 100%;
  cursor: e-resize;
  transition: background-color 0.3s;
}

.image-click-right:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

/* Lightbox Styles */
.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.lightbox-close {
  position: absolute;
  top: 20px;
  right: 30px;
  background: none;
  border: none;
  color: white;
  font-size: 50px;
  cursor: pointer;
  z-index: 10001;
}

.lightbox-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 80%;
}

.lightbox-image-container {
  max-width: 80%;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lightbox-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}

.lightbox-arrow {
  background: none;
  border: none;
  color: white;
  font-size: 4rem;
  cursor: pointer;
  padding: 20px;
  transition: color 0.3s;
}

.lightbox-arrow:hover {
  color: var(--dark-color-font);
}

.lightbox-indicators {
  margin-top: 30px;
  display: flex;
  gap: 15px;
}

.lightbox-indicators span {
  width: 15px;
  height: 15px;
  border: 2px solid white;
  cursor: pointer;
  transition: background-color 0.3s;
}

.lightbox-indicators span.active {
  background-color: white;
}

.price {
  white-space: pre-line;
  font-weight: bold;
  text-align: left;
  font-size: 15pt;
  letter-spacing: 4px;
}

.option {
  display: flex;
  justify-content: space-between;
  /* Umieszcza nagłówek po lewej, a cenę po prawej */
  align-items: center;
}

.option label {
  width: 50%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  font-size: 12px;
}

.option p {
  width: 50%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  font-size: 15px;
  text-align: center;
}

.option input {
  background-color: var(--dark-color-font);
  border: 2px solid var(--dark-color-background);
  text-align: center;
  width: 50%;
  padding: 10px;
  margin-bottom: 5px;
  appearance: auto;
  /* Firefox */
  -webkit-appearance: auto;
  /* Safari/Chrome */

}

.slider-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.arrow {
  background: transparent;
  border: 2px solid transparent;
  font-size: 2rem;
  cursor: pointer;
  pointer-events: all;
  color: var(--dark-color-background);
  transition: color 0.3s;
  height: 80%;
  width: 50px;
}

.arrow:hover {
  color: var(--dark-color-font);
  background-color: var(--dark-color-background);
  opacity: 0.5;
}

.left-arrow {
  position: absolute;
  left: -0px;
}

.right-arrow {
  position: absolute;
  right: -0px;
}


.products-list {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 20px;
  overflow-x: auto;
}



.prod-desc {
  margin: 10px 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* Ustawia elementy na górze */
  align-items: flex-start;
  /* Ustawia elementy od lewej strony */
}

.prod-price {
  margin: 30px 0;
  font-size: 11px;
  text-align: left;
  white-space: pre-line;
}

.right-column {
  border-left: 2px solid var(--dark-color-background);
  padding-left: 30px;
  width: 50%;
}


.block {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  margin: 20px 0px;
  width: 100%;
  border-left: 2px solid var(--dark-color-background);
  padding-left: 80px;
}

.product-info {
  width: 100%;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-row p {
  margin: 0;
  flex: 1;
  font-size: 16pt;
}

.product-options {
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-column {
  color: var(--dark-color-red);
}

.column {
  /* Upewnienie się, że marginesy są wyłączone */
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* Wymuszanie zawartości na początku */
}

.options .option {
  margin-bottom: 10px;
  /* Dodajemy margines pomiędzy opcjami */
}


.tags {
  border-bottom: 2px solid var(--dark-color-background);
  border-top: 2px solid var(--dark-color-background);
  padding: 20px 20px;
  width: 90%;
  display: block;
}

.tags p {
  font-size: 11px;
}


.product-button {
  text-align: center;
  background-color: var(--dark-color-background);
  color: var(--dark-color-font);
  padding: 5px 10px;
  letter-spacing: 2px;
  border: 1px solid transparent;
  transition: background 0.3s, color 0.3s;
  border: 2px solid transparent;
  text-decoration: none;
  text-transform: none;
  /* To nadpisuje ustawienie dużych liter */
  text-transform: uppercase;
}

.product-button:hover {
  background-color: var(--dark-color-font);
  color: var(--dark-color-background);
  border: 2px solid var(--dark-color-background);
}

.product-item {
  background-color: transparent;
  padding: 10px;
  margin: 0 20px;
  text-align: center;
  border: 1px solid transparent;
  min-width: 200px;
  display: flex;
  justify-content: center;
}


.product-item img {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 10px;
}


.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px;
  text-align: center;
}

.error-message {
  font-size: 18px;
  color: var(--dark-color-red);
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

@media (min-width: 823px) and (max-width: 1380px) {
  .right-column {
    width: 70%;
  }

  .product-image img {
    width: 300px;
    height: 300px;
    object-fit: contain;
    margin-top: 50px;
  }

  .image-controls {
    height: 300px;
    margin-top: 50px;
  }

  .image-click-areas {
    height: 300px;
    margin-top: 50px;
  }

  .product-item img {
    width: 120px;
    height: 120px;
    object-fit: contain;
  }

  .prod-price {
    margin: 20px 0;
  }

  .prod-desc {
    margin: 10px 10px;
  }

  .product-button {
    font-size: 11px;
  }

  .left-arrow {
    position: absolute;
    left: -20px;
  }

  .right-arrow {
    position: absolute;
    right: -20px;
  }

  .product-page {
    padding-bottom: 300px;
  }
}



@media (max-width: 822px) {

  .option {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0;
    /* usuń odstępy */
  }

  .option input {
    width: 70px;
    /* stała szerokość */
    margin: 0 5px;
    padding: 5px;
    text-align: center;
  }

  .stepper__btn {
    width: 32px;
    height: 32px;
    font-size: 22px;
    background: transparent;
    /* czarne tło */
    color: var(--dark-color-background);
    /* biały tekst */
    border: none;
    /* bez ramki */
    margin: 0 5px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .stepper__btn:hover {
    background: rgba(200, 200, 200, 0.2);
    ;
    /* lekko szare tło przy najechaniu */
    color: var(--dark-color-background);
    /* czarny symbol */
  }

  .stepper__btn:active {
    background: rgba(200, 200, 200, 0.2);
    ;
    color: var(--dark-color-background);
  }

  .product-page {

    width: 100%;
    padding: 10px;
    padding-top: 130px;
  }

  .product-info {
    padding: 0px;
    width: 100%;
  }

  .header-row p {
    font-size: 15px;
    line-height: 16pt;
  }

  .product-options {
    padding: 0px;
    margin-top: 40px;
    width: 100%;
    flex-direction: column;
    /* Ustawia elementy jedno pod drugim */
    justify-content: center;
    /* Opcjonalne - centruje elementy pionowo */
    align-items: stretch;
    /* Rozciąga elementy na pełną szerokość */
    height: auto;
    /* Automatyczna wysokość, dopasowana do zawartości */
  }

  .desc {
    margin: 10px 0;
    font-size: 10px;
    font-weight: normal;
  }


  .block {
    padding-left: 30px;
    flex-direction: row;
  }

  .right-column {
    width: 100%;
    border-left: none;
    padding-left: 0;
  }

  .product-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
  }

  .product-image img {
    width: 200px;
    height: 200px;
    object-fit: contain;
    margin: 0;
  }

  .image-controls {
    height: 200px;
  }

  .image-click-areas {
    height: 200px;
  }
}
</style>
